<template>
  <v-menu
    v-model="menuPicker"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
    ref="menuPicker"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :id="id"
        :value="dateFormatted"
        :label="label"
        :disabled="disabled"
        :prepend-icon="icon.today"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <div class="pa-0 white">
      <v-date-picker
        :value="value"
        @input="onInput($event)"
        no-title
        :min="minDate"
      ></v-date-picker>
    </div>
  </v-menu>
</template>

<script>
import { mdiCalendarToday } from '@mdi/js'
export default {
  name: 'ExpirationDate',
  props: {
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Fecha de expiración'
    },
    min: {
      type: String,
      default: null
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      icon: {
        today: mdiCalendarToday
      },
      menuPicker: false
    }
  },
  computed: {
    dateFormatted() {
      return this.value ? this.$moment(this.value).format('DD/MM/YYYY') : ''
    },
    minDate() {
      return this.min != null
        ? this.min
        : this.$moment()
            .add(1, 'days')
            .format('YYYY-MM-DD')
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
      this.$emit('change', event)
      this.$refs.menuPicker.save(event)
    }
  }
}
</script>
